export const formatLocation = (location: string): string => {
  const parts = location.split(',').map(part => part.trim());

  if (parts.length >= 3) {
    const [country, state, city] = parts;

    if (state !== '') {
      return `${city}, ${state}`;
    }

    return `${city}, ${country}`;
  }

  return location;
};
